function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  font-size: ", "px;\n  color: ", ";\n  margin: 0;\n  padding: 0;\n  margin-left: ", "px;\n  -webkit-font-smoothing: antialiased;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  /*\n  * Needed to have correct vertical aligntment across pages;\n  * otherwise, some pages will make this slightly taller, and\n  * shift up vertically.\n  */\n  line-height: 0;\n  margin-left: ", "px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: inline-flex;\n  flex-wrap: nowrap;\n  align-items: center;\n  text-decoration: none;\n  vertical-align: middle;\n  height: ", "px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import { Text } from '@doordash/design-language';
import styled from 'styled-components';
var lineHeight = 1.5;
export var Root = styled.div(_templateObject(), function (props) {
  return props.size * lineHeight;
});
export var LogoTextContainer = styled.div(_templateObject2(), function (props) {
  return props.leftSpacer;
});
export var Type = styled(Text).attrs({
  styles: Text.Styles.Caps14
})(_templateObject3(), function (props) {
  return props.size;
}, function (props) {
  return props.color;
}, function (props) {
  return props.leftSpacer;
});